import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Grid,
  Card,
  CardActionArea,
  Typography,
  Box,
  CircularProgress,
  DialogActions,
} from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import { getData } from "../../../services/library";
import { grey } from "@mui/material/colors";

function ModalSeleccionEmpresa({ open, onClose, onEmpresaSeleccionada }) {
  const [empresas, setEmpresas] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      cargarEmpresas();
    }
  }, [open]);

  const cargarEmpresas = async () => {
    setLoading(true);
    try {
      // getData("/empresas/", setEmpresas);
      const empresasHardcodeadas = [
      { idempresa: 2, empresa: "Italgas" },
      { idempresa: 4, empresa: "Natural Gas" },
    ];
    setEmpresas(empresasHardcodeadas);
    } catch (error) {
      console.error("Error al cargar empresas:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSeleccionarEmpresa = (empresa) => {
    onEmpresaSeleccionada(empresa.idempresa);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <Box mt={1} backgroundColor={"#1F618D"}>
        <DialogTitle>
          <Typography variant="h6" align="center" color="#ffffff">
            Descargar Fichas por empresa
          </Typography>
        </DialogTitle>
      </Box>
      <Box
        border={0.5}
        borderColor={grey[300]}
        backgroundColor="#F4F6F6"
        p={2}
        py={2}
        mt={1}
      >
        <DialogContent>
          {loading ? (
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: 200,
              }}
            >
              <Box sx={{ textAlign: "center" }}>
                <CircularProgress color="primary" />
                <Typography mt={2} color="textSecondary">
                  Cargando...
                </Typography>
              </Box>
            </Grid>
          ) : (
            <Grid container spacing={3} sx={{ p: 2, justifyContent: "center" }}>
              {empresas.map((empresa) => (
                <Grid item xs={12} sm={6} md={4} key={empresa.idempresa}>
                  <Card
                    sx={{
                      borderRadius: "10px",
                      backgroundColor: "#ffffff",
                      boxShadow: "0 3px 6px rgba(0,0,0,0.08)",
                      transition: "all 0.2s ease",
                      border: "1px solid #e0e0e0",
                      height: "100%",
                      "&:hover": {
                        transform: "translateY(-3px)",
                        boxShadow: "0 6px 12px rgba(0,0,0,0.12)",
                        borderColor: "#1F618D",
                      },
                    }}
                  >
                    <CardActionArea
                      onClick={() => handleSeleccionarEmpresa(empresa)}
                      sx={{
                        p: 2,
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          width: 48,
                          height: 48,
                          borderRadius: "50%",
                          bgcolor: "#ebf5fb",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mb: 1.5,
                        }}
                      >
                        <BusinessIcon sx={{ fontSize: 24, color: "#1F618D" }} />
                      </Box>
                      <Typography
                        variant="subtitle1"
                        fontWeight="600"
                        textAlign="center"
                        color="#1F618D"
                        sx={{
                          fontFamily: "'Roboto', sans-serif",
                          letterSpacing: "0.3px",
                          lineHeight: "1.3",
                        }}
                      >
                        {empresa.empresa}
                      </Typography>
                    </CardActionArea>
                  </Card>
                </Grid>
              ))}
            </Grid>
          )}
        </DialogContent>
      </Box>
      <DialogActions>
        <Button onClick={onClose} color="error" variant="contained">
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ModalSeleccionEmpresa;
